module.exports = __webpack_public_path__ + "img/Dismantler.6022df33.png";